React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_team_of_member')

module.exports = class extends React.Component
  render: t.renderable ->
    { name, shortLink } = @props.item

    t.a { href: "/b/#{ shortLink }", title: name }, ->
      t.div '.popover-item .u-clearfix', ->
        t.span '.popover-item-name', ->
          t.text name



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/board-of-team-component.coffee